import { render, staticRenderFns } from "./TherapyPt.vue?vue&type=template&id=e7c73798&scoped=true&"
import script from "./TherapyPt.vue?vue&type=script&lang=js&"
export * from "./TherapyPt.vue?vue&type=script&lang=js&"
import style0 from "./TherapyPt.vue?vue&type=style&index=0&id=e7c73798&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7c73798",
  null
  
)

export default component.exports